<template>
    <section id="content">
        <loader v-if="loader == true"></loader>
        <div class="page page-hz-menu-layout">
            <div class="row">
                <div class="col-md-8">
                    <section class="tile">
                        <div class="tile-header dvd dvd-btm">
                            <h1 class="custom-font"><strong>Contas</strong> de Pagamentos</h1>
                        </div>
                        <div class="tile-body">
                            <div class="row">
                                <div class="col-md-12 table-responsive">
                                    <p v-if="listaContas.length == 0" align="center"><br>Não exitem contas para pagamentos cadastradas.</p>
                                    <table class="table table-hover table-striped" v-if="listaContas.length > 0">
                                        <thead>
                                        <tr>
                                            <th>Descrição</th>
                                            <th>CPF/CNPJ</th>
                                            <th>Banco</th>
                                            <th>Conta</th>
                                            <th>Agencia</th>
                                            <th>Titular</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="lc in listaContas">
                                            <td>{{ lc.descricao }}</td>
                                            <td>{{ lc.cpfcnpj }}</td>
                                            <td>{{ lc.banco }}</td>
                                            <td>{{ lc.conta }}</td>
                                            <td>{{ lc.agencia }}</td>
                                            <td>{{ lc.titular }}</td>
                                            <td align="right">
                                                <button class="btn btn-danger btn-xs"
                                                        @click="excluir(lc.id)"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Excluir Conta">
                                                    <i class="fa fa-times"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="col-md-4">
                    <section class="tile">
                        <div class="tile-header dvd dvd-btm">
                            <h1 class="custom-font"><strong>Nova</strong> Conta de Pagamento</h1>
                            <ul class="controls">
                            </ul>
                        </div>
                        <div class="tile-body">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label>Descrição</label>
                                    <input type="text"
                                           class="form-control"
                                           v-model="banco.descricao"
                                           required>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <input-cpfcnpj></input-cpfcnpj>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-md-8">
                                    <label>Titular</label>
                                    <input type="text"
                                           class="form-control"
                                           v-model="banco.titular"
                                           required>
                                </div>
                                <div class="col-md-4">
                                    <label>Banco</label>
                                    <select name="banco" id="banco" v-model="banco.banco_id" class="form-control">
                                        <option v-for="b in bancos" :value="b.id">{{ b.banco }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-md-6">
                                    <label>Conta</label>
                                    <input type="text"
                                           v-mask="['#-#','##-#','###-#', '####-#', '#####-#', '######-#', '#######-#', '########-#', '#########-#']"
                                           class="form-control"
                                           placeholder="Conta"
                                           v-model="banco.conta"
                                           required>
                                </div>
                                <div class="col-md-6">
                                    <label>Agencia</label>
                                    <input type="text"
                                           v-mask="['#######']"
                                           class="form-control"
                                           placeholder="Agencia"
                                           v-model="banco.agencia"
                                           required>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12" align="center"><br>
                                    <button class="btn btn-success" @click="save()">
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import HeaderPropostas from './_header.vue';
    import TableFiler from '@/components/tables/Table.vue'
    const { API_URL } = process.env;
    import { mask } from 'vue-the-mask'

    export default {
        name: 'index-propostas',

        directives: {
            mask
        },

        data() {
            return{
                loader: false,
                listaContas: [],
                bancos: [],
                banco: {},
                fields: [
                    {
                        name: 'id',
                        prefix: 'id',
                        sortField: 'id',
                        title: '#'
                    },
                    {
                        name: 'nome',
                        prefix: 'pr.nome',
                        sortField: 'nome',
                        title: 'Nome'
                    },
                    {
                        name: 'cpfcnpj',
                        prefix: 'pr.cpfcnpj',
                        sortField: 'cpfcnpj',
                        title: 'CPF'
                    },
                    {
                        name: 'tipo_proposta',
                        prefix: 'tp.descricao',
                        sortField: 'tipo_proposta',
                        title: 'Tipo Proposta'
                    },
                    {
                        name: 'valor_proposta',
                        prefix: 'valor_proposta',
                        sortField: 'valor_proposta',
                        title: 'Valor Proposta R$',
                        callback: 'formatReal'
                    },
                    {
                        name: 'status_id',
                        sortField: 'status_id',
                        title: 'Situação',
                        callback: 'checkStatusProposta'
                    },
                    {
                        name: '__slot:actions',
                        title: ''
                    }

                ],
                url: API_URL + 'propostas'
            }
        },

        components: {
            'header-propostas': HeaderPropostas,
            'table-filter': TableFiler
        },

        methods: {

            getBancos: function () {
                var $this = this;
                $this.$http.get('/bancos')
                .then(function (response) {
                    $this.bancos = response.data;
                })
            },

            getlistaContas: function () {
                var $this = this;
                $this.loader = true;

                $this.$http.get('/lojista/conta')
                .then(function (response) {
                    $this.listaContas = response.data;
                    $this.loader = false;
                })
                .catch(function (error) {
                    $this.loader = false;
                })
            },

            onRowClass (dataItem) {

                if(dataItem.status_id == 10 || dataItem.status_id == 15) {
                    return 'alert alert-success';
                }

                if(dataItem.simulacao == true) {
                    if(dataItem.aprovacao_automatica == false) {
                        return 'tr-default';
                    } else {
                        return 'alert alert-cyan';
                    }
                } else {
                    if(dataItem.aprovacao_automatica == false) {
                        return 'alert alert-warning';
                    } else {
                        return 'alert alert-cyan';
                    }
                }
            },

            save: function () {

                var $this = this;

                if($('#cpfcnpj').val() == '') {
                    return this.$toastr('warning', 'Informe o CPF/CNPJ do titular da conta.', 'Atenção!');
                }

                $this.loader = true;

                $this.banco.cpfcnpj = $('#cpfcnpj').val();

                $this.$http.post('/lojista/conta', $this.banco)
                .then(function (response) {
                    $this.loader = false;
                    $this.banco = {};
                    $('#cpfcnpj').val('');
                    $this.$toastr('success', 'Banco cadastrado com sucesso.', 'Atenção!');
                    $this.getlistaContas();
                })
                .catch(function (error) {
                    $this.loader = false;
                })
            },

            excluir: function (id) {

                var $this = this;
                $this.loader = true;

                swal({
                    title: "Atenção",
                    text: 'Deseja realmente excluir está conta?',
                    type: "warning",
                    buttons: true,
                    showCancelButton: true,
                    dangerMode: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                })
                .then((willDelete) => {
                    if (willDelete.value) {
                    $this.$http.delete('/lojista/conta/' + id)
                    .then(function () {
                        $this.getlistaContas();
                        $this.loader = false;
                        swal.close();
                    });
                } else {
                    $this.loader = false;
                    swal.close();
                }
            });
            }
        },

        mounted() {
            this.getBancos();
            this.getlistaContas();
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/configuracoes/contas/Index.vue